/**
 * modal.remote
 * Display a modal based on a provided data attribute set to remove something
 *
 * @package Monapix
 * @version 3.0.1
 * @author Binary Cats Inc.
 */

$(function()
{
    "use strict";
    // Complete modal, cached
    let modal = $('#remote .modal-content-loader').html();
    // Define the container to replace

    // When we display
    $('body').on('click.modal.data-api', '[data-toggle="modal"]', function(){
        /*
            we need to pass the following:
            data-target="{url}"
            we may pass the data-container to replace, by default 'modal-content'
            data-container=".modal-content"
         */
        let container = $(this).data("container") || '.modal-content'
        let remote = $(this).data('remote');

        // Trigger
        if (remote) {
            $($(this).data("target") + ' ' + container).load(remote);
        }
    });
    // Hide the item
    $('body').on('hidden.bs.modal', '#remote', function () {
        // Remove the inline data from the modal
        $(this).removeData('bs.modal');
        // Replace data with a loader
        $(this).find('.modal-content').html(modal);
    });
});



// WEBPACK FOOTER //
// ./resources/js/services/jquery/modal.remote.js